import getEmbeddedManifest from '../utils/embedded-manifest';

export const key = 'hubspot';

export const integration = () =>
  getEmbeddedManifest({
    key,
    dashboardWidget: {
      title: 'hubspot.widget.title',
      description: 'hubspot.widget.description',
    },
    requiredPermissions: ['my-account.manage-html-embeds'],
  });
